// import React, { useState, useMemo } from "react";
// import styles from "./UserList.module.css";
// import Table from "./Table/Table";
// import usersData from "../../DummyData/Customers/UserList";
// import Sidebar from "../../../../CommonComponets/SideBar";
// import PromoteAsAssociate from "../../../AssociatePanel/Pages/CustomerArea/PromoteAsAssociate/PromoteAsAssociate";
// import BusinessAddCustomer from "../../Pages/CustomerArea/AddCustomer/AddCustomer";

// const UserList = () => {
//   const [activeTab, setActiveTab] = useState("All");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedRole, setSelectedRole] = useState("All");
//   const [isCustomerAdd, setIsCustomer] = useState(false);

//   const getDaysAgo = (days: number) => {
//     const date = new Date();
//     date.setDate(date.getDate() - days);
//     return date;
//   };

//   const parseDate = (str: string) => {
//     const [day, month, year] = str.split("-");
//     return new Date(Number(year), Number(month) - 1, Number(day));
//   };

//   // --- Logic: Dynamic Filtering (The "API" results simulation) ---
//   const filteredUsers = useMemo(() => {
//     return usersData.filter((user) => {
//       // 1. Tab Filtering
//       const userDate = parseDate(user.CreatedOn);
//       if (activeTab === "Active" && user.Status !== "Y") return false;
//       if (activeTab === "KYC Pending" && user.KYCStatus !== "N") return false;
//       if (activeTab === "Last 15 Days" && userDate < getDaysAgo(15))
//         return false;
//       if (activeTab === "Last 30 Days" && userDate < getDaysAgo(30))
//         return false;
//       // 2. Role Filtering (If you add a role key to your data)
//       if (selectedRole !== "All" && user.CustomerType !== selectedRole)
//         return false;
//       // 3. Search Filtering
//       const searchLower = searchTerm.toLowerCase();
//       return (
//         user.CustomerName.toLowerCase().includes(searchLower) ||
//         user.PrimaryMobile.includes(searchTerm) ||
//         user.EmailID.toLowerCase().includes(searchLower)
//       );
//     });
//   }, [activeTab, searchTerm, selectedRole]);

//   // --- Logic: Dynamic Tab Counts ---
//   const tabs = [
//     { label: "All", count: usersData.length },
//     {
//       label: "Active",
//       count: usersData.filter((u) => u.Status === "Y").length,
//       color: "#e6f4ea",
//     },
//     {
//       label: "KYC Pending",
//       count: usersData.filter((u) => u.KYCStatus === "N").length,
//       color: "#fff7e6",
//     },
//     {
//       label: "Last 15 Days",
//       count: usersData.filter((u) => parseDate(u.CreatedOn) >= getDaysAgo(15))
//         .length,
//       color: "#fce8e6",
//     },
//     {
//       label: "Last 30 Days",
//       count: usersData.filter((u) => parseDate(u.CreatedOn) >= getDaysAgo(30))
//         .length,
//       color: "#f1f3f4",
//     },
//   ];

//   return (
//     <div className={styles.container}>
//       <header className={styles.header}>
//         <h1>Customer List</h1>
//         <button
//           className={styles.addButton}
//           onClick={() => setIsCustomer(true)}
//         >
//           + Add Customer
//         </button>
//       </header>
//       {/* {isPromoting && (
//         <Sidebar
//           // setIsFilter={() => setIsPromoting((prev) => !prev)}
//           heading="Promote Customer to Associate!"
//           subHeading="Upgrade this member’s role to an associate level"
//           minWidth={550}
//         >
//           <PromoteAsAssociate
//           // defaultValues={{
//           //   ...promotingUserData,
//           // }}
//           // setIsPromoting={setIsPromoting}
//           />
//         </Sidebar>
//       )} */}
//       {isCustomerAdd && (
//         <Sidebar
//           setIsFilter={() => setIsCustomer((prev) => !prev)}
//           heading="Add Your Next Customer & Build A Strong Foundation For Success!"
//         >
//           <BusinessAddCustomer
//           // getSelfCustomerList={getSelfCustomerList}
//           // getCustomerList={getCustomerList}
//           // setIsCustomer={setIsCustomer}
//           />
//         </Sidebar>
//       )}
//       {/* Tabs Section */}
//       <div className={styles.tabsContainer}>
//         {tabs.map((tab) => (
//           <button
//             key={tab.label}
//             className={`${styles.tab} ${activeTab === tab.label ? styles.activeTab : ""}`}
//             style={
//               activeTab === tab.label ? { borderBottomColor: tab.color } : {}
//             }
//             onClick={() => setActiveTab(tab.label)}
//           >
//             {tab.label} <span className={styles.count}>{tab.count}</span>
//           </button>
//         ))}
//       </div>

//       {/* Filters Section */}
//       <div className={styles.filterBar}>
//         <div className={styles.selectGroup}>
//           <select
//             className={styles.select}
//             value={selectedRole}
//             onChange={(e) => setSelectedRole(e.target.value)}
//           >
//             <option value="All">All Types</option>
//             <option value="Y">Type Y</option>
//             <option value="N">Type N</option>
//           </select>
//         </div>

//         <div className={styles.searchWrapper}>
//           <input
//             type="text"
//             placeholder="Search by name, phone or email..."
//             className={styles.searchInput}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>
//       </div>

//       {/* Table Section */}
//       <Table users={filteredUsers} />
//     </div>
//   );
// };

// export default UserList;

import React, { useState, useMemo, useEffect } from "react";
// @ts-ignore
import styles from "./UserList.module.css";
import Table from "./Table/Table";
import usersData from "../../DummyData/Customers/UserList";
import Sidebar from "../../../../CommonComponets/SideBar";
// import BusinessAddCustomer from "../../Pages/CustomerArea/AddCustomer/AddCustomer";
const BusinessAddCustomer = React.lazy(
  () => import("../../Pages/CustomerArea/AddCustomer/AddCustomer"),
);
const PromoteAsAssociate = React.lazy(
  () =>
    import("../../../AssociatePanel/Pages/CustomerArea/PromoteAsAssociate/PromoteAsAssociate"),
);

import { MdAddCircleOutline, MdClose, MdFilterListOff } from "react-icons/md";

const UserList = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("All");
  const [isCustomerAdd, setIsCustomer] = useState(false);
  const [promoteAsAssociate, setpromoteAsAssociate] = useState(false);

  const [loading, setLoading] = useState(false);
  // --- Helper: Date Formatting Logic ---
  const getDaysAgo = (days: number) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
  };

  const parseDate = (str: string) => {
    const [day, month, year] = str.split("-");
    return new Date(Number(year), Number(month) - 1, Number(day));
  };

  // --- Logic: Clear All Filters ---
  const handleClearAll = () => {
    setActiveTab("All");
    setSearchTerm("");
    setSelectedRole("All");
  };

  const isFilterActive =
    activeTab !== "All" || searchTerm !== "" || selectedRole !== "All";

  // --- Logic: Dynamic Filtering ---
  const filteredUsers = useMemo(() => {
    return usersData.filter((user) => {
      // 1. Tab Filtering
      const userDate = parseDate(user.CreatedOn);
      if (activeTab === "Active" && user.Status !== "Y") return false;
      if (activeTab === "KYC Pending" && user.KYCStatus !== "N") return false;
      if (activeTab === "Last 15 Days" && userDate < getDaysAgo(15))
        return false;
      if (activeTab === "Last 30 Days" && userDate < getDaysAgo(30))
        return false;

      // 2. Role Filtering
      if (selectedRole !== "All" && user.CustomerType !== selectedRole)
        return false;

      // 3. Search Filtering
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        user.CustomerName.toLowerCase().includes(searchLower) ||
        user.PrimaryMobile.includes(searchTerm) ||
        user.EmailID.toLowerCase().includes(searchLower);

      return matchesSearch;
    });
  }, [activeTab, searchTerm, selectedRole]);

  // --- Logic: Dynamic Tab Counts ---
  const tabs = [
    { label: "All", count: usersData.length, color: "#3b82f6" },
    {
      label: "Active",
      count: usersData.filter((u) => u.Status === "Y").length,
      color: "#e6f4ea",
    },
    {
      label: "KYC Pending",
      count: usersData.filter((u) => u.KYCStatus === "N").length,
      color: "#fff7e6",
    },
    {
      label: "Last 15 Days",
      count: usersData.filter((u) => parseDate(u.CreatedOn) >= getDaysAgo(15))
        .length,
      color: "#fce8e6",
    },
    {
      label: "Last 30 Days",
      count: usersData.filter((u) => parseDate(u.CreatedOn) >= getDaysAgo(30))
        .length,
      color: "#f1f3f4",
    },
  ];
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [filteredUsers]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.titleArea}>
          <h1>Customer List</h1>
          <p className={styles.subTitle}>
            Manage and monitor your customer base
          </p>
        </div>
        <button
          className={styles.addButton}
          onClick={() => setIsCustomer(true)}
        >
          <MdAddCircleOutline className={styles.btnIcon} />
          Add Customer
        </button>
      </header>

      {/* Sidebar for Add Customer */}

      {isCustomerAdd && (
        <Sidebar
          setIsFilter={() => setIsCustomer((prev) => !prev)}
          heading="Add New Customer"
          subHeading="Build a strong foundation for your business success"
        >
          <BusinessAddCustomer />
        </Sidebar>
      )}

      {/* Sidebar for Promote As Associate */}
      {/*  @ts-ignore */}
      {promoteAsAssociate && (
        <Sidebar setIsFilter={() => setpromoteAsAssociate((prev) => !prev)}>
          <PromoteAsAssociate />
        </Sidebar>
      )}

      {/* Tabs Section */}
      <div className={styles.tabsContainer}>
        {tabs.map((tab) => (
          <button
            key={tab.label}
            className={`${styles.tab} ${activeTab === tab.label ? styles.activeTab : ""}`}
            style={
              activeTab === tab.label ? { borderBottomColor: tab.color } : {}
            }
            onClick={() => setActiveTab(tab.label)}
          >
            {tab.label} <span className={styles.count}>{tab.count}</span>
          </button>
        ))}
      </div>

      {/* Filters Section */}
      <div className={styles.filterBar}>
        <div className={styles.filterInputs}>
          <div className={styles.selectGroup}>
            <select
              className={styles.select}
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              <option value="All">All Types</option>
              <option value="Y">Type Y (Associate)</option>
              <option value="N">Type N (General)</option>
            </select>
          </div>

          <div className={styles.searchWrapper}>
            <input
              type="text"
              placeholder="Search by name, phone or email..."
              className={styles.searchInput}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Active Filter Chips */}
      {isFilterActive && (
        <div className={styles.chipsContainer}>
          {activeTab !== "All" && (
            <div className={styles.chip}>
              Tab: {activeTab}
              <MdClose
                className={styles.closeIcon}
                onClick={() => setActiveTab("All")}
              />
            </div>
          )}
          {selectedRole !== "All" && (
            <div className={styles.chip}>
              Type: {selectedRole}
              <MdClose
                className={styles.closeIcon}
                onClick={() => setSelectedRole("All")}
              />
            </div>
          )}

          {searchTerm && (
            <div className={styles.chip}>
              Search: "{searchTerm}"
              <MdClose
                className={styles.closeIcon}
                onClick={() => setSearchTerm("")}
              />
            </div>
          )}

          {isFilterActive && (
            <div
              className={`${styles.chip} ${styles.clearAllBtn}`}
              onClick={handleClearAll}
            >
              <MdFilterListOff /> Clear All
            </div>
          )}
        </div>
      )}

      {/* Table Section */}
      <Table
        users={filteredUsers}
        loading={loading}
        handlePromoteAsAssociate={() => setpromoteAsAssociate(true)}
      />
    </div>
  );
};

export default UserList;
